/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import {
  GetAppointmentsSuccessfulActionPayload,
  GetAppointmentByIdActionPayload,
  GetAppointmentByIdSuccessfulActionPayload,
  CreateAppointmentActionPayload,
  CreateAppointmentSuccessfulActionPayload,
  UpdateAppointmentActionPayload,
  UpdateAppointmentSuccessfulActionPayload,
  DeleteAppointmentActionPayload,
  DeleteAppointmentSuccessfulActionPayload,
} from 'src/app/features/shared/models/event/appointment-data-store';

/* action types */
export enum ActionTypes {
  GetAppointments = '[APPOINTMENT] GetAppointments',
  GetAppointmentsSuccessful = '[APPOINTMENT] GetAppointmentsSuccessful',
  GetAppointmentsFailure = '[APPOINTMENT] GetAppointmentsFailure',
  GetAppointmentById = '[APPOINTMENT] GetAppointmentById',
  GetAppointmentByIdSuccessful = '[APPOINTMENT] GetAppointmentByIdSuccessful',
  GetAppointmentByIdFailure = '[APPOINTMENT] GetAppointmentByIdFailure',
  CreateAppointment = '[APPOINTMENT] CreateAppointment',
  CreateAppointmentSuccessful = '[APPOINTMENT] CreateAppointmentSuccessful',
  CreateAppointmentFailure = '[APPOINTMENT] CreateAppointmentFailure',
  UpdateAppointment = '[APPOINTMENT] UpdateAppointment',
  UpdateAppointmentSuccessful = '[APPOINTMENT] UpdateAppointmentSuccessful',
  UpdateAppointmentFailure = '[APPOINTMENT] UpdateAppointmentFailure',
  DeleteAppointment = '[APPOINTMENT] DeleteAppointment',
  DeleteAppointmentSuccessful = '[APPOINTMENT] DeleteAppointmentSuccessful',
  DeleteAppointmentFailure = '[APPOINTMENT] DeleteAppointmentFailure',
  ResetState = '[APPOINTMENT] ResetState',
}

/* actions */

/* This event gets the all Appointments. */
export const GetAppointments = createAction(ActionTypes.GetAppointments);

/* This event is fired after getting all the Appointments successfully. */
export const GetAppointmentsSuccessful = createAction(
  ActionTypes.GetAppointmentsSuccessful,
  props<{ payload: GetAppointmentsSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get all the Appointments. */
export const GetAppointmentsFailure = createAction(
  ActionTypes.GetAppointmentsFailure,
);

/* This event gets the Appointment by Appointment id. */
export const GetAppointmentById = createAction(
  ActionTypes.GetAppointmentById,
  props<{ payload: GetAppointmentByIdActionPayload }>(),
);

/* This event is fired after getting all the Appointment by Appointment id successfully. */
export const GetAppointmentByIdSuccessful = createAction(
  ActionTypes.GetAppointmentByIdSuccessful,
  props<{ payload: GetAppointmentByIdSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't get the Appointment by Appointment id successfully. */
export const GetAppointmentByIdFailure = createAction(
  ActionTypes.GetAppointmentByIdFailure,
);

/* This event creates a Appointment. */
export const CreateAppointment = createAction(
  ActionTypes.CreateAppointment,
  props<{ payload: CreateAppointmentActionPayload }>(),
);

/* This event is fired after creating a Appointment successfully. */
export const CreateAppointmentSuccessful = createAction(
  ActionTypes.CreateAppointmentSuccessful,
  props<{ payload: CreateAppointmentSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't create a Appointment successfully. */
export const CreateAppointmentFailure = createAction(
  ActionTypes.CreateAppointmentFailure,
);

/* This event updates a Appointment. */
export const UpdateAppointment = createAction(
  ActionTypes.UpdateAppointment,
  props<{ payload: UpdateAppointmentActionPayload }>(),
);

/* This event is fired after updating a Appointment successfully. */
export const UpdateAppointmentSuccessful = createAction(
  ActionTypes.UpdateAppointmentSuccessful,
  props<{ payload: UpdateAppointmentSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't update a Appointment successfully. */
export const UpdateAppointmentFailure = createAction(
  ActionTypes.UpdateAppointmentFailure,
);

/* This event deletes a Appointment. */
export const DeleteAppointment = createAction(
  ActionTypes.DeleteAppointment,
  props<{ payload: DeleteAppointmentActionPayload }>(),
);

/* This event is fired after deleting a Appointment successfully. */
export const DeleteAppointmentSuccessful = createAction(
  ActionTypes.DeleteAppointmentSuccessful,
  props<{ payload: DeleteAppointmentSuccessfulActionPayload }>(),
);

/* This event is fired after couldn't delete a Appointment successfully. */
export const DeleteAppointmentFailure = createAction(
  ActionTypes.DeleteAppointmentFailure,
);

/* This event resets the Appointment state. */
export const ResetState = createAction(ActionTypes.ResetState);
